import { __values } from "tslib";
export var fixOffsetsModifer = {
    order: 890,
    enabled: true,
    fn: function (data) {
        var e_1, _a;
        try {
            for (var _b = __values([
                'transform',
                'msTransform',
                'WebkitTransform',
                'MozTransform',
                'OTransform',
            ]), _c = _b.next(); !_c.done; _c = _b.next()) {
                var property = _c.value;
                var tranformValue = data.styles[property];
                if (tranformValue) {
                    var matchValue = tranformValue.match(/translate3d\((\d+)px, (\d+)px, 0\)/);
                    if (matchValue) {
                        var dpr = window.devicePixelRatio;
                        var x = Math.round(Number(matchValue[1]) * dpr) / dpr;
                        var y = Math.round(Number(matchValue[2]) * dpr) / dpr;
                        data.styles.transform = "translate3d(" + x + "px, " + y + "px, 0)";
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return data;
    },
};
